import { render, staticRenderFns } from "./HostDebugbar.vue?vue&type=template&id=6bd2f52b&"
import script from "./HostDebugbar.vue?vue&type=script&lang=ts&"
export * from "./HostDebugbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports